// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".draggable-dominfo-placeholder{height:10px;display:block;overflow:hidden;background:#000!important;width:100%;position:absolute;left:0;z-index:1}.draggable-dominfo-placeholder:hover{background:#409eff!important}.el-table-draggable__empty-table{min-height:60px}.el-table-draggable__empty-table table{width:100%;height:100%;min-height:60px;position:absolute;z-index:99}.el-table-draggable__empty-table tbody{position:absolute;width:100%;min-height:100%}", ""]);
// Exports
module.exports = exports;
